import styled from 'styled-components'

const getLinkColor = props => props.theme.shell.footer.copyright.color
const getHoverLinkColor = props => props.theme.shell.footer.copyright.hoverColor

const FooterLinksView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: right;
  gap: 24px;

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    display: block;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.landscape}px) {
    margin-top: 0;
  }

  a {
    color: ${getLinkColor};
    display: inline-block;
    text-decoration: none;

    .selected {
      font-family: ${({theme}) => theme.font.fontBold};
      color: ${getHoverLinkColor};
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
      margin-bottom: 0;
      margin-left: 20px;
    }

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      color: ${getHoverLinkColor};
      text-decoration: underline;
    }
  }
`

export default FooterLinksView
